// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__jYBSR","author":"Table_author__1P4pB","authorImage":"Table_authorImage__Rd49j","unreadRow":"Table_unreadRow__3TLaW"};